module.exports = require("is-debugging");